import React from 'react';
import {NodeInterface} from "../interfaces";
import styled from "styled-components/macro";
import colors from "../../../styles/variables/colors";

interface NodeProps {
  node: NodeInterface
}

export const FlickityResultItem = styled.a`
  display: block;
  width: 402px;
  height: auto;
  background-color: ${colors.white.base};
  margin-right: 4px;
  &:last-child {
    margin-right: 0;
  }

  &:hover {
    .skew_small img {
      transform: translate3d(-50%, -50%, 0) scale(0.95);
    }
    img {
      transform: translate3d(-50%, -50%, 0) scale(0.98);
    }
  }
`;

export const Image = styled.div`
  position: relative;
  display: block;
  overflow: hidden;
  width: 402px;
  height: 227px;
  img {
    transform: translate3d(-50%, -50%, 0);
    transition: all cubic-bezier(.62,.28,.23,.99) 0.3s;
    position: absolute;
    left: 50%;
    top: 50%;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
  &.skew_small img {
    filter: drop-shadow(0 30px 60px rgba(0, 0, 0, 0.35));
    transform: translate3d(-50%, -50%, 0) scale(1.2);
  }
`;

export const Catch = styled.div`
  color: ${colors.orange.base};
  font-family: 'Helvetica Now Text W01 Bold', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1em;
  letter-spacing: 0.03em;
  margin: -5px 0 5px 0;
  text-transform: uppercase;
  min-height: 16px;
`;

export const Title = styled.h4`
  color: ${colors.slate.base};
  font-family: 'Helvetica Now Text W01 Bold', sans-serif;
  font-weight: 700;
  font-size: 24px;
  margin: -8px 0 0 0;
  letter-spacing: -0.03em;
  text-transform: uppercase;
`;

export const Lip = styled.div`
  padding: 24px 20px;
`;

type ResultSliderItemComponent = (props: NodeProps) => JSX.Element;

const ResultSliderItem: ResultSliderItemComponent = ({node}) => {

  const NodeImage = () => {
    if (node.image?.derivates) {
      return (
        <Image className={node.imageStyle}>
          <img alt={node.title} src={node.image.derivates[Object.keys(node.image.derivates)[0]]}/>
        </Image>
      )
    }
    return <></>
  }

  return (
    <FlickityResultItem key={`flickity-sub-item:${node.id}`} href={node.link} target={'_blank'}>
      <NodeImage />
      <Lip>
        <Catch>{node.catch}</Catch>
        <Title>{node.title}</Title>
      </Lip>
    </FlickityResultItem>
  )
}
export default ResultSliderItem;
